<template>
  <div
    :class="`block-container ${containerClass || ''}`"
    data-cy="block-container"
  >
    <header :class="headerClass || ''" data-cy="block-header">
      <slot name="header">
        <h3 data-cy="block-header-text">{{ headerText }}</h3>
        <span class="block__close" @click="close" data-cy="close-button"
          ><font-awesome-icon icon="times"
        /></span>
      </slot>
    </header>
    <div :class="`block-content ${contentClass || ''}`" data-cy="block-content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watchEffect } from "vue";

export interface Props {
  open?: boolean;
  containerClass?: string;
  contentClass?: string;
  headerClass?: string;
  headerText?: string;
  canBeClosed?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
  contentClass: "",
  headerClass: "",
  headerText: "",
  canBeClosed: true,
});

const isOpen = ref<boolean>(props.open);

const emit = defineEmits<{
  (e: "close", closed: boolean): void;
}>();

const close = function () {
  const closed = props.canBeClosed == undefined || props.canBeClosed;
  if (closed) isOpen.value = false;
  emit("close", closed);
};

watchEffect(() => {
  isOpen.value = props.open;
});
</script>

<style scoped lang="scss">
.block-container {
  background-color: var(--color-white);
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #fffcea;
  color: #666;

  header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;

    .block__close {
      cursor: pointer;
      font-size: 1rem;
    }
  }
}
</style>
